import { Link } from 'react-router-dom';
import './HomePage.css'; // Add this to style your homepage

function HomePage() {
  return (
    <>
      <div className="homepage-container">
        <h1 className="homepage-title">Judolingo</h1>
        <p className="homepage-subtitle">Vælg hvilken tilstand du vil bruge til at lære Judo.</p>
        <div className="button-container">
          <Link to="/quiz" className="quiz-link">Pensum Quiz</Link>
          <Link to="/pensum" className="quiz-link">Pensum</Link>
          <Link to="/Words" className="quiz-link">Judo ord Quiz</Link>
          <Link to="/Kata" className="quiz-link">Kata</Link>
          <Link to="/WordSearch" className="quiz-link">Ord Søgning</Link>
          <Link to="/WrittenQuiz" className="quiz-link">Skrive Quiz</Link>
          <Link to="/Judolingo" className="quiz-link">Judolingo</Link>
        </div>
        <div className="info-notice">
          Billedmateriale tilhører Dansk Judo & Ju-Jitsu Union (DJU).<br />
          © Dansk Judo & Ju-Jitsu Union. Alle rettigheder forbeholdes.<br />
          <span style={{ fontWeight: 'bold' }}>Denne app er ikke officielt tilknyttet DJU.</span>
        </div>
      </div>
    </>
  );
}

export default HomePage;
